module.exports = __webpack_public_path__ + "static/media/Edit.22432da0.svg";